import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=1259745c&scoped=true"
var script = {}
import style0 from "./Logout.vue?vue&type=style&index=0&id=1259745c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1259745c",
  null
  
)

export default component.exports